import type { ComponentChildren } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { Icon } from './icons';
export function Sheet({
  title,
  eyebrow,
  children,
  onClose,
  className = ''
}: {
  title: string;
  eyebrow?: string;
  children: ComponentChildren;
  onClose: () => void;
  className?: string;
}) {
  const panel = useRef<HTMLElement>(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const frame = requestAnimationFrame(() => panel.current?.focus());
    const keydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close.current();
      }
      if (event.key === 'Tab') {
        const nodes = [...(panel.current?.querySelectorAll<HTMLElement>('button:not(:disabled),a[href],input:not(:disabled),textarea,select,[tabindex="0"]') || [])].filter(el => el.getClientRects().length);
        const first = nodes[0],
          last = nodes[nodes.length - 1];
        if (!first) {
          event.preventDefault();
          return;
        }
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel.current)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel.current)) {
          event.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener('keydown', keydown);
    return () => {
      cancelAnimationFrame(frame);
      document.body.style.overflow = oldOverflow;
      document.removeEventListener('keydown', keydown);
      if (previous?.isConnected) previous.focus();
    };
  }, []);
  return <div class="sheet-backdrop" onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }}><section ref={panel} class={`sheet ${className}`} role="dialog" aria-modal="true" aria-labelledby="sheet-title" tabIndex={-1}><div class="sheet-handle" /><div class="sheet-close-anchor"><button class="icon-button sheet-close" aria-label="Close sheet" onClick={onClose}><Icon name="close" /></button></div><header class="sheet-heading">{eyebrow && <div class="eyebrow">{eyebrow}</div>}<h2 id="sheet-title">{title}</h2></header>{children}</section></div>;
}
